import { render, staticRenderFns } from "./penggunasistem.vue?vue&type=template&id=212f54be"
import script from "./penggunasistem.vue?vue&type=script&lang=js"
export * from "./penggunasistem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports